import { StatusPill } from '../models/shared/status-pill';

export function buildSplitStatusPill(hasSplitLegs: boolean | null | undefined): StatusPill | null {
  return hasSplitLegs ? new StatusPill(0, $localize`Split`, '#552773', '#EFE6F1') : null;
}
